import React from 'react';
import { useTranslation } from 'react-i18next';

import Img_Bespaar from '../../image/simple/undraw_investing.svg';
import Img_Inzicht from '../../image/simple/undraw_data_trends.svg';
import Img_Join from '../../image/simple/undraw_join.svg';

export const WhySection = ({ whyCards }) => {
  const { t } = useTranslation();

  return (
    <div class="vb-home-content-contrast vb-home-content-contrast--hero">
      <div class="container vb-home-content">
        <div class="row vb-padding-mobile">
          <div class="col-lg-12">
            <h5 class="vb-about-subtitle-center">{t('home.why.title')}</h5>
          </div>
        </div>
        <div class="row vb-gbs-grid">
          <div class="p-4 col-lg-4 col-sm-12 vb-home-card-title">
            <img src={Img_Bespaar} class="vb-img-card" alt="Besparen en waarde toevoegen"></img>
            <h2>{whyCards[0]?.title || ''}</h2>
            <h4 class="vb-home-card-text">{whyCards[0]?.text || ''}</h4>
          </div>
          <div class="p-4 col-lg-4 col-sm-12 vb-home-card-title">
            <img src={Img_Inzicht} class="vb-img-card" alt="Inzicht en analyse"></img>
            <h2>{whyCards[1]?.title || ''}</h2>
            <h4 class="vb-home-card-text">{whyCards[1]?.text || ''}</h4>
          </div>
          <div class="p-4 col-lg-4 col-sm-12 vb-home-card-title">
            <img src={Img_Join} class="vb-img-card" alt="Service en onderhoud"></img>
            <h2>{whyCards[2]?.title || ''}</h2>
            <h4 class="vb-home-card-text">{whyCards[2]?.text || ''}</h4>
          </div>
        </div>
      </div>
    </div>
  );
};
